import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

export default function Notfound() {
  return (
    <div>
      <div>
      <div
        className="
    flex
    items-center
    justify-center
    w-screen
    h-screen
   
  "
      >
        <div className="px-40 py-20 bg-gray-300 rounded-md shadow-xl">
          <div className="flex flex-col items-center">
            <h1 className="font-bold bg-clip-text bg-gradient-to-br from-purple-600 to-blue-400 text-transparent text-9xl">404</h1>

            <h6 className="mb-2 text-2xl font-bold text-center text-white md:text-3xl">
              <span className="text-red-500">Oops!</span> Page not found
            </h6>

            <p className="mb-8 text-center text-gray-500 md:text-lg">
              The page you’re looking for doesn’t exist.
            </p>

            <a
              href="/"
              className="px-6 py-2 text-sm font-semibold text-blue-800 bg-gray-200 rounded hover:scale-110 transition-ease duration-200"
            >
              Go home
            </a>
          </div>
        </div>
      </div>
    </div>

    </div>
  )
}
